import { useCurrentUnit } from '../hooks/useCurrentUnit.js'

// Calm empty state shown for per-unit tabs while the All-Units roll-up
// is active. Per-unit surfaces (stock, schedule, insights, marketing,
// settings) are scoped to a single restaurant, so when the operator is
// viewing every unit at once we ask them to pick which unit to work in
// rather than rendering a broken or ambiguous screen.
//
// Tapping a unit calls switchUnit(id), which flips mode back to 'group'
// and returns the operator to normal per-unit tab content.
//
// Props:
//   action — a short verb phrase, e.g. "receive a delivery".
export default function SelectUnitPrompt({ action }) {
  const { allUnits, switchUnit } = useCurrentUnit()

  // Transient/loading: allUnits not yet populated. Show a calm neutral
  // line rather than an empty picker.
  if (!allUnits || allUnits.length === 0) {
    return (
      <div className="mx-auto max-w-screen-sm px-4 py-10 text-center text-sm text-black/50">
        Loading your units…
      </div>
    )
  }

  return (
    <div className="mx-auto max-w-screen-sm px-4 py-8">
      <div className="rounded-xl border border-dashed border-black/15 px-4 py-8 text-center">
        <p className="text-sm text-black/70">
          Select a unit to {action}.
        </p>
        <div className="mt-5 grid grid-cols-1 gap-2 sm:grid-cols-2">
          {allUnits.map((unit) => (
            <button
              key={unit.id}
              type="button"
              onClick={() => switchUnit(unit.id)}
              className="
                rounded-lg border border-amber-brand-200 bg-white px-4 py-2.5
                text-sm font-medium text-amber-brand-800 shadow-sm transition
                hover:bg-amber-brand-50 hover:border-amber-brand-400
              "
            >
              {unit.name}
            </button>
          ))}
        </div>
      </div>
    </div>
  )
}
